import {
    NEW_DESPESA_DIRETA_CADASTRO_SUCCESS,
    TABLE_DESPESA_DIRETA_CADASTRO_PENDING,
    TABLE_DESPESA_DIRETA_CADASTRO_SUCCESS,
    TABLE_DESPESA_DIRETA_CADASTRO_FAILURE,
    LIST_DESPESA_DIRETA_CADASTRO_PENDING,
    LIST_DESPESA_DIRETA_CADASTRO_SUCCESS,
    LIST_DESPESA_DIRETA_CADASTRO_FAILURE,
    FIND_DESPESA_DIRETA_CADASTRO_PENDING,
    FIND_DESPESA_DIRETA_CADASTRO_SUCCESS,
    FIND_DESPESA_DIRETA_CADASTRO_FAILURE,
    DELETE_DESPESA_DIRETA_CADASTRO_PENDING,
    DELETE_DESPESA_DIRETA_CADASTRO_SUCCESS,
    DELETE_DESPESA_DIRETA_CADASTRO_FAILURE,
    CREATE_DESPESA_DIRETA_CADASTRO_PENDING,
    CREATE_DESPESA_DIRETA_CADASTRO_SUCCESS,
    CREATE_DESPESA_DIRETA_CADASTRO_FAILURE,
    CANCEL_DESPESA_DIRETA_CADASTRO_RAPIDO_SUCCESS,
} from './actionTypes';


const initialState = { list: null, loading: false }


function despesaDiretaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_DESPESA_DIRETA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_DESPESA_DIRETA_CADASTRO_PENDING:
        case FIND_DESPESA_DIRETA_CADASTRO_PENDING:
        case DELETE_DESPESA_DIRETA_CADASTRO_PENDING:
        case CREATE_DESPESA_DIRETA_CADASTRO_PENDING:
        case TABLE_DESPESA_DIRETA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_DESPESA_DIRETA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_DESPESA_DIRETA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_DESPESA_DIRETA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_DESPESA_DIRETA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_DESPESA_DIRETA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_DESPESA_DIRETA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_DESPESA_DIRETA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_DESPESA_DIRETA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_DESPESA_DIRETA_CADASTRO_SUCCESS:
        case CREATE_DESPESA_DIRETA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_DESPESA_DIRETA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { despesaDiretaCadastroReducer };